
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ParteProps } from '../../interfaces/comun/ParteInterface';
import { AnexoProps } from '../../interfaces/comun/AnexoInterface';
import { TipoConceptoProps } from '../../interfaces/catalogos/TipoConceptoInterface';

import { FolioProps } from '../../interfaces/comun/FolioInterface';
import { AmparoProps } from '../../interfaces/comun/AmparoInterface';
import { ExpedienteProps } from '../../interfaces/comun/ExpedienteInterface';
import { ExhortoRecibidoProps } from '../../interfaces/comun/ExhortoRecibidoInterface';
import { AnexoBuzonElectronicoProps } from '../../interfaces/comun/RecepcionInterface';

export const defaultExpediente: ExpedienteProps = { idExpediente: 0, numeroExpediente: '', numeroFolio: '', cuantia: '', idTipoJuicio: 0, tipoJuicio: '', actor: [], demandado: [], };
export const defaultExhortoRecibido: ExhortoRecibidoProps = { idExhortoRecibido: 0, numeroFolio: '', numeroExhorto: '', numeroExpedienteOrigen: '', cuantia: '', idTipoJuicio: 0, tipoJuicio: '', idAutoridadExhorto: 0, autoridadExhorto: '', actor: [], demandado: [], };
export const defaultAmparo: AmparoProps = { idAmparo: 0, numeroAmparo: '', numeroAmparoOrigen: '', numeroExpediente: '', idTipoAmparo: 0, tipoAmparo: '', idAutoridadAmparo: 0, autoridadAmparo: '', partes: [], };
export const defaultFolio: FolioProps = { idFolio: 0, numeroFolio: '', numeroExpediente: '', numeroExhortoRecibido: '', cuantia: '', tipoJuicio: '', tipoCalificacion: '', partes: [], generarExpediente: false, observaciones: '', esExhorto: false, }

export interface stateProps {
    id?:                       string;
    idMateria?:                number;
    materia?:                  string;
    idTipoJuicio?:             number;
    tipoJuicio?:               string;
    idPresentante?:            number;
    presentante?:              string;
    recibidoPorReloj?:         boolean;
    fechaReloj?:               string;
    recibidoPaqueteria?:       boolean;
    
    provieneBuzonElectronico?: boolean;
    folioBuzonElectronico?:    string;
    escritoBuzonElectronico?:  string;
    anexosBuzonElectronico?:   AnexoBuzonElectronicoProps[];
   
    acuse?:                    string;
    acuseFirmado?:             string;
    numeroExpediente?:         string;
    fechaRecepcion?:           string;
    numeroExhorto?:            string;
    numeroExpedienteOrigen?:   string;
    idAutoridadExhorto?:       number;
    autoridadExhorto?:         string;
    idTipoPromocion?:          number;
    tipoPromocion?:            string;

    idAutoridad?:              number;
    autoridad?:                string;   
    juzgadoOrigen?:            string; 
   
    idTipoAmparo?:              number;
    tipoAmparo?:                string;
    idAutoridadAmparo?:         number;
    autoridadAmparo?:           string;
    dirigidoExpediente?:        boolean;
    numeroAmparo?:              string;
    numeroAmparoOrigen?:        string;
    referencia?:                string;
    telefonoCelular?:           string;
    cuantia?:                   string;
    numeroFolio?:               string;

    expediente?:                ExpedienteProps;
    exhortoRecibido?:           ExhortoRecibidoProps;
    amparo?:                    AmparoProps;
    folio?:                     FolioProps;  
    partes?:                    ParteProps[];
    conceptos?:                 TipoConceptoProps[];
    anexos?:                    AnexoProps[];
}

const initialState : stateProps = {
    id:                       '',
    idMateria:                0,
    materia:                  '',
    idTipoJuicio:             0,
    tipoJuicio:               '',
    idPresentante:            0,
    presentante:              '',
    recibidoPorReloj:         false,
    fechaReloj:               '',
    recibidoPaqueteria:       false,
    provieneBuzonElectronico: false,
    folioBuzonElectronico:    '',
    escritoBuzonElectronico:  '',
    anexosBuzonElectronico:   [],
    acuse:                    '',
    acuseFirmado:             '',
    numeroExpediente:         '',
    fechaRecepcion:           '',
    numeroExhorto:            '',
    numeroExpedienteOrigen:   '',
    idAutoridadExhorto:       0,
    autoridadExhorto:         '',
    idTipoPromocion:          0,
    tipoPromocion:            '',
    idAutoridad:              0,
    autoridad:                '',    
    juzgadoOrigen:            '',
    idTipoAmparo:             0,
    tipoAmparo:               '',   
    idAutoridadAmparo:        0,
    autoridadAmparo:          '',   
    dirigidoExpediente:       false,
    numeroAmparo:             '',   
    numeroAmparoOrigen:       '',   
    referencia:               '',   
    telefonoCelular:          '',   
    cuantia:                  '',
    numeroFolio:              '',
    expediente:               defaultExpediente,
    exhortoRecibido:          defaultExhortoRecibido,
    amparo:                   defaultAmparo,
    folio:                    defaultFolio,
    partes:                   [],
    conceptos:                [],
    anexos:                   [],
};

export const recepcionSlice = createSlice({
    name: 'recepcion',
    initialState: initialState,
    reducers: {
        setReducerRecepcion: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.id =                          payload.id;
            state.idMateria =                   payload.idMateria;
            state.materia =                     payload.materia;
            state.idTipoJuicio =                payload.idTipoJuicio;
            state.tipoJuicio =                  payload.tipoJuicio;
            state.idPresentante =               payload.idPresentante;
            state.presentante =                 payload.presentante;
            state.recibidoPorReloj =            payload.recibidoPorReloj;
            state.fechaReloj =                  payload.fechaReloj;
            state.recibidoPaqueteria =          payload.recibidoPaqueteria;
            state.provieneBuzonElectronico =    payload.provieneBuzonElectronico;
            state.folioBuzonElectronico =       payload.folioBuzonElectronico;
            state.escritoBuzonElectronico =     payload.escritoBuzonElectronico;
            state.anexosBuzonElectronico =      payload.anexosBuzonElectronico;
            state.acuse =                       payload.acuse;
            state.acuseFirmado =                payload.acuseFirmado;
            state.numeroExpediente =            payload.numeroExpediente;
            state.fechaRecepcion =              payload.fechaRecepcion;
            state.numeroExhorto =               payload.numeroExhorto;
            state.numeroExpedienteOrigen =      payload.numeroExpedienteOrigen;
            state.idAutoridadExhorto =          payload.idAutoridadExhorto;
            state.autoridadExhorto =            payload.autoridadExhorto;
            state.idTipoPromocion =             payload.idTipoPromocion;
            state.tipoPromocion =               payload.tipoPromocion;
            state.idAutoridad =                 payload.idAutoridad;
            state.autoridad =                   payload.autoridad;
            state.juzgadoOrigen =               payload.juzgadoOrigen;
            state.idTipoAmparo =                payload.idTipoAmparo;
            state.tipoAmparo =                  payload.tipoAmparo;
            state.idAutoridadAmparo =           payload.idAutoridadAmparo;
            state.autoridadAmparo =             payload.autoridadAmparo;
            state.dirigidoExpediente =          payload.dirigidoExpediente;
            state.numeroAmparo =                payload.numeroAmparo;
            state.numeroAmparoOrigen =          payload.numeroAmparoOrigen;
            state.referencia =                  payload.referencia;
            state.telefonoCelular =             payload.telefonoCelular;
            state.cuantia =                     payload.cuantia;
            state.expediente =                  payload.expediente;
            state.exhortoRecibido =             payload.exhortoRecibido;
            state.amparo =                      payload.amparo;
            state.folio =                       payload.folio;
            state.numeroFolio =                 payload.numeroFolio;
        },
        setReducerPartes: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.partes = payload.partes;
        },
        setReducerConceptos: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.conceptos = payload.conceptos;
        },
        setReducerAnexos: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.anexos = payload.anexos;
        },
        setReducerClear: ( state ) => {
            state = initialState;
        },
    },
})

export const { setReducerRecepcion, setReducerPartes, setReducerConceptos, setReducerAnexos, setReducerClear } = recepcionSlice.actions

export default recepcionSlice.reducer